import { BitfPRequestMapper } from '@bitf/core/parsers/p-parser';
import { EBitfParsers } from '@enums';

export class AppRequestMapper extends BitfPRequestMapper {
  name = EBitfParsers.BITF_APP_PARSER;
}
